export const scrollToError = (
	errorClass = "input[aria-invalid='true']",
	outerElement = 'fieldset'
): boolean => {
	let errorElement = document.querySelector(errorClass);
	if (errorElement) {
		if (outerElement && 'closest' in errorElement) {
			errorElement = errorElement.closest(outerElement);
		}

		if (errorElement) {
			errorElement.scrollIntoView({
				behavior: 'smooth',
			});

			return true;
		}
	}

	return false;
};
